import colors from "@packages/colors";

export const WHITELABEL_FONTS = [
    "Akt",
    "Montserrat",
    "Inter",
    "Josefin Sans",
    "Roboto",
    "Open Sans",
    "Rubik",
    "DM Sans",
    "Poppins",
    "Lato",
    "Nunito",
    "Ubuntu",
    "Source Sans Pro",
    "Work Sans",
    "Manrope",
    "Helvetica",
    "Arial",
];

export const WHITELABEL_DEFAULT_STYLE = {
    font: "Akt",
    primary: colors.primary,
    accent: colors.accent,
    charts: colors.charts.doughnut,
};

export const WHITELABEL_PLATFORM_DEFAULT = {
    title: "WiFeed",
    supportMode: null,
    supportEmail: "",
    style: {
        font: WHITELABEL_DEFAULT_STYLE.font,
        primary: WHITELABEL_DEFAULT_STYLE.primary,
        accent: WHITELABEL_DEFAULT_STYLE.accent,
        background: colors.primary,
        charts: WHITELABEL_DEFAULT_STYLE.charts,
    },
};
